import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
   container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(3),
  },
  root: {
    minWidth: 275,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  fieldSpacing:{
    padding:'5px'
  },
  errorColor: {
    color:'red'
  },
   formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
  text:{
    fontSize:'1rem'
  },
  text2:{
    fontSize:'0.875rem',
    fontWeight:"normal"
  },
  emailLink:{
    textDecoration: "none",
    color: theme.palette.primary.main, 
    fontSize: '1rem'
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main, 
    fontSize: '1rem'
  },
  photo:{
    maxWidth:200
  },
  statusBg: {
    borderRadius: '2px',
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '1px',
    paddingRight: '12px',
    paddingLeft: '12px'
  },
  fileNameLinkTxt:{
    textDecoration: "none",
    color: theme.palette.primary.main, 
    fontSize: '1rem',
    width: '250px',whiteSpace:'nowrap',overflow: 'hidden',textOverflow:'ellipsis'
  }
}));
